import { DashboaredHeader } from "../../components/sharedComponents/DashboaredHeader";
import React from "react";
import ReservBars from "./ReservBars";
import SalesBars from "./SalesBars";
import { useIntl } from "react-intl";
import { CallAPI } from "../../config/api/ApiConfig";
import { DashboaredHeaderBanner } from "../../components/sharedComponents/DashboaredHeaderBanner";

const Chart = () => {
    const { messages } = useIntl();

    const { data: stats } = CallAPI({
        name: "dashboardChartStats",
        url: "/mentor/v1/dashboard-booking-sessions?days=7",
        refetchOnWindowFocus: false,
        enabled: true,
        select: (res) => res?.data?.data,
    });

    const completed = stats?.complete?.length || 0;
    const scheduled = stats?.schedule || 0;
    const notAttended =
        stats?.not_attended ||
        stats?.complete?.reduce(
            (acc, curr) => (curr.attend_status === 0 ? acc + 1 : acc),
            0,
        ) ||
        0;
    const totalReservations =
        completed + scheduled + (stats?.not_attended || 0);

    const statCards = [
        {
            value: totalReservations,
            label: messages["total_reservations"] || "Total Reservations",
            color: "var(--tertiary)",
        },
        {
            value: scheduled,
            label: messages["scheduled"],
            color: "var(--tertiary)",
        },
        {
            value: completed,
            label: messages["completed"],
            color: "var(--tertiary)",
        },
        {
            value: notAttended,
            label: messages["not_attended"] || "Not Attended",
            color: "var(--danger)",
        },
    ];

    return (
        <div className="chart_wrapper">
            <div className="container-fluid">
                <div className="row">
                    {/* <div className="col-md-6 ">
                        <DashboaredHeader
                            text={messages["reservations_graph"]}
                            className="heading_dash"
                        />

                        <div className="chart_box mb-3 ">
                            <ReservBars />
                        </div>
                    </div>
                    <div className="col-md-6">
                        {
                            // <DashboaredHeader
                            //  text={messages["sales_graph"]}
                            //  className="heading_dash"
                            // />
                        }
                        <div className="chart_box mb-3">
                            <SalesBars />
                        </div>
                    </div> */}

                    {/* Welcome banner */}
                    <div className="col-12 mb-4">
                        <DashboaredHeaderBanner
                            text={
                                messages["welcome_dashboard"] ||
                                "Welcome to Your Dashboard"
                            }
                            description={
                                messages["welcome_dashboard_desc"] ||
                                "This is the main dashboard where you can see an overview of your activities."
                            }
                            className="dashboard-welcome-banner"
                        />
                    </div>

                    {/* Stat cards */}
                    {statCards.map((card, i) => (
                        <div className="col-md-3 col-sm-6 mb-3" key={i}>
                            <div className="dashboard-stat-card">
                                <span
                                    className="dashboard-stat-card__value"
                                    style={{ color: card.color }}
                                >
                                    {card.value}
                                </span>
                                <span className="dashboard-stat-card__label">
                                    {card.label}
                                </span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Chart;
